/* bundle builder */
try {
  $("body").delegate(".parent_item .quantity-selector", "click", function () {
    document.body.classList.add("refreshing_cart");
    setTimeout(function () {
      document.body.classList.remove("refreshing_cart");
    }, 6000);
  });

  $("body").delegate(
    ".parent_item .line-item__remove-button",
    "click",
    function () {
      document.body.classList.add("refreshing_cart");
      setTimeout(function () {
        document.body.classList.remove("refreshing_cart");
      }, 6000);
    }
  );
} catch (e) {}
if (document.querySelector(".product-bundle-add-product")) {
  $(".product__info #AddToCart").text(atcBtnTxtBefore + " 01");
}
$(function () {
  function bundleProductClose() {
    $(".product-bundle-popup-overlay").removeClass("open");
    $(".product-bundle-popup").removeClass("open");
  }
  function stepProducts(step) {
    var originalStep = step;
    if (step) {
      var step = step;
      $(".product-bundle-products-selection").each(function () {
        var firstBlank = $(this).find(
          ".product-bundle-add-product:not(.added):first"
        );
        $(".product-bundle-add-product").removeClass("first-blank");
        $(firstBlank).addClass("first-blank");
        console.log($(firstBlank));
        step = $(firstBlank).attr("data-step");
      });
      step = step ? step : originalStep;
      if (originalStep) {
        step = originalStep;
      }
      $(
        ".bundle-popup-products .bundle-popup-products-block-wrapper"
      ).removeClass("open");
      let el = $(
        ".bundle-popup-products-block-wrapper[data-step='" + step + "']"
      );
      $(el).addClass("open");
      $(".bundle-popup-title").text($(el).attr("data-block-title"));
    }
  }
  function bundleProductOpen(step) {
    $(".product-bundle-popup-overlay").addClass("open");
    $(".product-bundle-popup").addClass("open");
    $(
      ".bundle-popup-products .bundle-popup-products-block-wrapper"
    ).removeClass("open");

    if (step) {
      stepProducts(step);
    } else {
      $(".bundle-popup-products .bundle-popup-products-block-wrapper")
        .eq(0)
        .addClass("open");
    }
  }
  $(".product-bundle-popup-overlay").click(function () {
    bundleProductClose();
  });
  $(".bundle-popup-products-block-btn").click(function (e) {
    document.querySelector("#AddToCart").click();
    setTimeout(function () {
      bundleProductClose();
    }, 1);
  });
  $(".bundle-popup-close").click(function (e) {
    bundleProductClose();
  });
  $(".product-bundle-add-product").click(function (e) {
    bundleProductOpen($(this).attr("data-step"));

    stepProducts($(this).attr("data-step"));

    $(".product-bundle-add-product").removeClass("first-blank");
    var that = this;
    $(".product-bundle-products-selection").each(function () {
      var getClicked = $(this)
        .find(".product-bundle-add-product")
        .eq($(that).index());
      $(getClicked).addClass("first-blank");
    });
  });
  function setActiveProduct(vid, title, img, step, p, cp) {
    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(
        `.product-bundle-add-product[data-step="${step}"]`
      );
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
       $(removeEl).find(".step-price").remove();
      
    });

    $(".product-bundle-products-selection").each(function () {
      var firstElement = $(
        `.product-bundle-add-product[data-step="${step}"]:not(.added)`
      );
      firstElement.addClass("added");
      $(firstElement).attr("data-vid", vid);
      const pimg = `<img src="${img}" class="p-img">`;
      const ptitle = `<p class="p-title">${
        title.length > 35 ? title.substring(0, 25) + "..." : title
      }</p>`;
      var price = p / 100;
      var comprice = cp / 100;
      var priceTemp;

      if (comprice > price) {
        priceTemp = `<div class="step-price"><span class="step-price-price has-compare">€${price}</span> <span class="step-price-comprice">€${comprice}</span></div>`;
      } else {
        priceTemp = `<div class="step-price"><span class="step-price-price">€${price}</span></div>`;
      }

      $(firstElement).find(".product-bundle-add-product-img").append(pimg);
      firstElement.append(ptitle);
      firstElement.append(priceTemp);

      var firstBlank = $(this).find(
        ".product-bundle-add-product:not(.added):first"
      );
      stepProducts($(firstBlank).attr("data-step"));
    });
  }
  function removeActiveProduct(varaintId, index) {
    let foundFirst = false;

    activeProducts = activeProducts.filter((el) => {
      if (!foundFirst && el.vid == varaintId) {
        foundFirst = true;
        return false;
      }
      return true;
    });

    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(".product-bundle-add-product").eq(index);
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
    });

    updateDOM(activeProducts);
  }
  function updateBundlePrice() {
    let bundlePrice = parseFloat(
      document
        .querySelector(".product-bundle-wrapper")
        .getAttribute("data-price")
    );
    let bundleComPrice = parseFloat(
      document
        .querySelector(".product-bundle-wrapper")
        .getAttribute("data-comprice")
    );

    let totalPrice = 0;
    let totalComPrice = 0;

    // Calculate total price and total compare price for continuous products
    activeProducts.forEach((product) => {
      if (product.continuous === true || product.optional  === true ) {
        totalPrice += product.price;
        totalComPrice += product.comprice;
      }
    });

    // Add the bundle price and compare price
    totalPrice += bundlePrice;
    totalComPrice += bundleComPrice;

    // Update the price display
    let productPrices = document.querySelector("[data-product-price-list]");
    if (!productPrices) return;

    let currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;

    productPrices.innerHTML = "";

    // Calculate and display the savings
    let savings = 0;
    if (totalComPrice > totalPrice) {
      savings = totalComPrice - totalPrice;
      let savingsText = "";

      if (window.themeVariables.settings.discountMode === "percentage") {
        savingsText = `${Math.round((savings * 100) / totalComPrice)}%`;
      } else {
        savingsText = formatMoney(savings); // Format savings as money
      }

      productPrices.innerHTML = `<span class="price price--highlight">
                                <span class="visually-hidden">${
                                  window.themeVariables.strings.productSalePrice
                                }</span>
                                ${formatMoney(totalPrice, currencyFormat)}
                               </span>`;
      productPrices.innerHTML += `<span class="price price--compare">
                                <span class="visually-hidden">${
                                  window.themeVariables.strings
                                    .productRegularPrice
                                }</span>
                                ${formatMoney(totalComPrice, currencyFormat)}
                               </span>`;

      // Update label with savings
      let productLabelList = document.querySelector(
        "[data-product-label-list]"
      );
      if (productLabelList) {
        productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace(
          "@savings@",
          savingsText
        )}</span>`;
      }
    } else {
      // Optionally, display a different message if no discount
      productPrices.innerHTML = `<span class="price">${formatMoney(
        totalPrice,
        currencyFormat
      )}</span>`;

      let productLabelList = document.querySelector(
        "[data-product-label-list]"
      );
      if (productLabelList) {
        productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.noDiscount}</span>`;
      }
    }
  }

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."),
        dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  function updateDOM(activeProducts) {
    updateBundlePrice();
    let activeProductsLength = activeProducts.length;
    // $(".number-of-selected-items").text(activeProductsLength);
    // let percent = (activeProductsLength / numberOfSteps) * 100;
    // $(".product-bundle-popup .progress-bar-fill").css({
    //   width: percent + "%",
    // });
    var buttons = document.querySelectorAll(".bundle-popup-products-block-btn");
    if (activeProductsLength >= numberOfSteps) {
      // $(".bundle-popup-products-block-btn").removeAttr("disabled");
      // // $(".product-bundle-wrapper").addClass("filled");
      // $(".product__info #AddToCart").removeAttr("disabled");
      // $("#StickyAddToCart").removeAttr("disabled");
      // buttons.forEach((button) => {
      //   const dataText = "Set in den Warenkorb packen";
      //   button.textContent = dataText;
      // });
      let bundlePrice = parseFloat(
        document
          .querySelector(".product-bundle-wrapper")
          .getAttribute("data-price")
      );

      let totalPrice = 0;

      activeProducts.forEach((product) => {
        if (product.continuous === true || product.optional === true) {
          totalPrice += product.price;
        }
      });

      totalPrice += bundlePrice;

      let finalPrice = totalPrice / 100;

      let formattedPrice = "€" + finalPrice.toFixed(2).replace(".", ",");

      $(".product__info #AddToCart").text(
        atcBtnTxtAfter + ` | ${formattedPrice}`
      );
    } else {
      // // $(".product-bundle-wrapper").removeClass("filled");
      // $(".bundle-popup-products-block-btn").attr("disabled", true);
      // // $(".product__info #AddToCart").attr("disabled", true);
      // // $("#StickyAddToCart").attr("disabled", true);
      // buttons.forEach((button) => {
      //   const dataText = button.getAttribute("data-text");
      //   button.textContent = dataText;
      // });

      $(".product__info #AddToCart").text(
        atcBtnTxtBefore + ` 0${activeProductsLength + 1}`
      );
    }
    bundleProductClose();
    updateVisibility();

    // var productPrice =
    //   parseFloat(
    //     document
    //       .querySelector(".price-list [data-ed-price]")
    //       .getAttribute("data-ed-price")
    //   ) / 100;
    // var total = productPrice;
    // var additionalPrices = [];

    // // Der initiale Text wird später definiert, basierend darauf, ob Zusatzoptionen vorhanden sind
    // var temp = "";

    // activeProducts.forEach(function (el) {
    //   if (el.price > 0) {
    //     additionalPrices.push(el.price.toFixed(2) + "€"); // Fügt nur den Preis hinzu, wenn er größer als 0 ist
    //     total += parseFloat(el.price);
    //   }
    // });

    // Zusätzliche Preise in den String einfügen, falls vorhanden
    // if (additionalPrices.length > 0) {
    //   var additionalPricesString = additionalPrices.join(" + ");
    //   temp = `<strong>Set:</strong> ${productPrice}€ + Auswahl: ${additionalPricesString} = <strong class="final-price">${total.toFixed(
    //     2
    //   )}€</strong>`;
    // } else {
    //   // Zeigt nur den Basispreis an, wenn keine Zusatzoptionen über 0€ gewählt wurden
    //   temp = `<strong>Set:</strong> ${productPrice}€`;
    // }

    // Verwendung von .html() um sicherzustellen, dass HTML-Tags korrekt interpretiert werden
    // $(".product-bundle-popup-header-left").html(temp);
  }
  $(".bundle-popup-products-block-product").click(function (e) {
    e.preventDefault();
    var stepAdded = false;

    let step = $(this).attr("data-step");
    // let doubleProduct =
    //   $(this).attr("data-doubleproduct") === "true" ? true : false;

    for (let item of activeProducts) {
      if (item.step == step) {
        stepAdded = true;
      }
    }

    if (!$(this).hasClass("soldout")) {
      let vid = $(this).attr("data-vid");
      let title = $(this).attr("data-title");
      let img = $(this).attr("data-img");
      let index = parseInt(
        $(this)
          .parents(".bundle-popup-products-block-wrapper")
          .attr("data-index")
      );
      let price = parseFloat($(this).attr("data-price"));
      let comprice = parseFloat($(this).attr("data-comprice"));
      if (isNaN(comprice)) {
        comprice = price;
      }
      let optional = $(this).attr("data-optional") === "1" ? true : false;

      let continuous = $(this).hasClass("continuous") ? true : false;
      console.log(continuous);

      activeProducts = activeProducts.filter(function (item) {
        return item.step !== step;
      });

      activeProducts.push({
        vid,
        title,
        img,
        step,
        price,
        comprice,
        optional,
        index,
        continuous,
      });
      setActiveProduct(vid, title, img, step, price, comprice);
      updateDOM(activeProducts);
      console.log(activeProducts);
    }
  });

  $(".bundle-product-cross").click(function (e) {
    e.preventDefault();
    let parent = $(this).parents(".product-bundle-add-product");
    removeActiveProduct($(parent).attr("data-vid"), $(parent).index());
  });

  // function updateVisibility() {
  //   const productBundles = document.querySelectorAll(
  //     ".product-bundle-products-selection"
  //   );

  //   productBundles.forEach((bundle) => {
  //     const continuousElements = bundle.querySelectorAll(
  //       ".product-bundle-add-product.continuous"
  //     );
  //     const allProductElements = bundle.querySelectorAll(
  //       ".product-bundle-add-product"
  //     );
  //     continuousElements.forEach((element) => {
  //       element.style.display = "none";
  //     });

  //     let allNonContinuousAdded = true;
  //     for (let i = 0; i < allProductElements.length; i++) {
  //       if (
  //         !allProductElements[i].classList.contains("continuous") &&
  //         !allProductElements[i].classList.contains("added")
  //       ) {
  //         allNonContinuousAdded = false;
  //         break;
  //       }
  //     }

  //     continuousElements.forEach((element, index) => {
  //       // if (index === 0) {
  //       //   element.style.display = "block";
  //       //   return;
  //       // }

  //       let allPreviousContinuousAdded = true;
  //       for (let i = 0; i < index; i++) {
  //         if (continuousElements[i].classList.contains("added") === false) {
  //           allPreviousContinuousAdded = false;
  //           break;
  //         }
  //       }

  //       if (allNonContinuousAdded && allPreviousContinuousAdded) {
  //         element.style.display = "block";
  //       } else {
  //         element.style.display = "none";
  //       }
  //     });
  //   });
  // }


function updateVisibility() {
  const productBundles = document.querySelectorAll(".product-bundle-products-selection");

  productBundles.forEach((bundle) => {
    const allProductElements = Array.from(
      bundle.querySelectorAll(".product-bundle-add-product")
    );

    allProductElements.forEach((element, index) => {
      const isContinuous = element.classList.contains("continuous");

      if (!isContinuous) {
        // Show non-continuous steps by default
        element.style.display = "block";
        return;
      }

      // For continuous steps, check all *previous* steps only
      let allPreviousValid = true;

      for (let i = 0; i < index; i++) {
        const prev = allProductElements[i];

        if (!prev.classList.contains("added")) {
          allPreviousValid = false;
          break;
        }
      }

      element.style.display = allPreviousValid ? "block" : "none";
    });
  });
}


  updateVisibility();
});

/* bundle builder */

$(document).ready(function () {
  $(document).on("click", ".mini-cart button.upsell_btn", function () {
    console.log("cart add");
    $(this).addClass("loading");
    var id = $(this).data("pro-id");
    console.log(id);
    var arrPdp = [];
    if (id != "") {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: id,
        },
        dataType: "json",
        success: function (data) {
          $(".mini-cart button.upsell_btn").removeClass("loading");
          // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true}));
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: data,
            })
          );

          setTimeout(function () {
            $(".free-gift-item-wrap.active").hide();
          }, 1000);
        },
      });
    }
  });

  if ($("body").hasClass("template-product")) {
    $(document).find(".template-product #upsell_slider").slick({
      infinite: false,
      slidesToShow: 1.4,
      slidesToScroll: 1,
      arrows: false,
    });

    $(document).on("click", ".product__info button.upsell_btn", function () {
      console.log("pro");
      $(this).addClass("loading");
      var id = $(this).data("pro-id");
      console.log(id);
      var arrPdp = [];
      if (id != "") {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: id,
          },
          dataType: "json",
          success: function (data) {
            // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true}));
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: data,
              })
            );
            var cartDrawerButtonSelector =
              "a.header__icon-wrapper[aria-controls='mini-cart']";
            var cartDrawerButton = document.querySelector(
              cartDrawerButtonSelector
            );
            setTimeout(function () {
              cartDrawerButton.click();
              $(".product__info button.upsell_btn button").removeClass(
                "loading"
              );

              setTimeout(function () {
                $(".free-gift-item-wrap.active").hide();
              }, 1000);
            }, 1000);
          },
        });
      }
    });
  }
});
